
export const ProficiencyLevel = () => {
  return [{ level: "Basic" }, { level: "Conversational" }, { level: "Fluent" }];
};

export const BookingFilter=()=>{
  return [
    { value: "BookingDate", label: "Booking date" },
    { value: "CreatedAt", label:"Created date" },
    {value: "LatestCreated", label: "Latest created"}];
}

export const OnlineStatus = () => {
  return [
    { status: "1 Hour" },
    { status: "1 Day" },
    { status: "1 Week" },
    { status: "Forever" },
  ];
};
export const UserRole = {
  Buyer: "Buyer",
  Seller: "Seller",
};

/** Matches backend ReferralSourceType for Profile/UpdateProfessionalCategorySkills */
export const ReferralSourceType = {
  Instagram: 1,
  LinkedIn: 2,
  Facebook: 3,
  GoogleSearch: 4,
  YouTube: 5,
  ReferralFriend: 6,
  Advertisement: 7,
  Other: 50,
} as const;

export type ReferralSourceTypeValue =
  (typeof ReferralSourceType)[keyof typeof ReferralSourceType];

export const ReferralSourceTypeOptions: Array<{
  label: string;
  value: ReferralSourceTypeValue;
}> = [
  { label: "Instagram", value: ReferralSourceType.Instagram },
  { label: "LinkedIn", value: ReferralSourceType.LinkedIn },
  { label: "Facebook", value: ReferralSourceType.Facebook },
  { label: "Google Search", value: ReferralSourceType.GoogleSearch },
  { label: "YouTube", value: ReferralSourceType.YouTube },
  { label: "Friend Referral", value: ReferralSourceType.ReferralFriend },
  { label: "Advertisement", value: ReferralSourceType.Advertisement },
  { label: "Other", value: ReferralSourceType.Other },
];

/** Backend enum member name for referralName (e.g. 6 → "ReferralFriend") */
export const getReferralSourceTypeName = (
  source: ReferralSourceTypeValue | null | undefined
): string => {
  if (source == null) return "";
  const entry = (
    Object.entries(ReferralSourceType) as Array<
      [keyof typeof ReferralSourceType, ReferralSourceTypeValue]
    >
  ).find(([, value]) => value === source);
  return entry?.[0] ?? "";
};

export const orderStatusColorCode={
  PENDING: "#DFC228",
  APPROVED: "#00c78d",
  REJECTED: "#CE3932",
  OVERDUE: "",
  CANCELLED: "#CE3932",
  COMPLETED: "",
  SUBMITTED: "#DFC228",
  RESCHEDULE: "#DFC228",
  PAYMENTPENDING: "#DFC228",
  NotAvailable:"#4a2696",
  MyMeetings:"#00c78d"
}

export const ApprovalStatus = {
  PENDING: "PENDING",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  OVERDUE: "OVERDUE",
  CANCELLED: "CANCELLED",
  COMPLETED: "COMPLETED",
  SUBMITTED: "SUBMITTED",
  RESCHEDULE: "RESCHEDULE",
  PAYMENTPENDING: "PAYMENTPENDING"
};
export const previousPath = [
  "/seller-calender",
  "/consultation/",
];

export const NoDataFound = {
  ARTICLES: "No articles created yet",
  CONSULTATION: "No consultations created yet",
  CONSULTATION_HISTORY: "No consultation history available",
  ORDER: "No orders available",
  UPCOMMING_ORDER: "No upcoming orders available",
  CREDIT_CARD: "No card added",
  BILLING_HISTORY: "No billing history available",
  DELETE_HISTORY: "No deleted history available",
  NOTIFICATION: "No notifications available",
  FAVOURITE_CONSULTANT: "No favorite consultants available",
  FAVOURITE_CONSULTANCY: "No favorite consultations available",
  FAVOURITE_ARTICLE: "No favorite articles available",
  ACCOUNT_DETAIL: "No bank account history available",
  NODATAFOUND: "No data found",
  NORESULTFOUND: "No result found for ",
  PRICING_HISTORY: "No pricing history available",
};

export const EntityType={
    CONSULTATION: "Consultation",
    MESSAGE: "Message",
    SELLER: "Seller",
    BUYER: "Buyer", 
    ARTICLE: "Article",
    ORDER: "Order",
}  
export const ReactionType={
  LIKE: "like",
  DISLIKE: "dislike",
}

export const ImageFileExtensions = [".jpg",
 ".jpeg", ".bmp", ".gif", ".png",".webp"];

 export const SlotBookingType = {
  WORKING_HOURS:0,
  TIME_AWAY:1,
  VACATION:2
 }

 export const WorkingDays = {
  Sunday: 0,
  Monday: 1,
  Tuesday: 2,
  Wednesday: 3,
  Thursday: 4,
  Friday: 5,
  Saturday: 6,
 }

 export const sellerPath = ["/consultation/create","/consultation/preview","/consultation/my-consultation","/consultation/deleted"];
 export const userTheme = {
    Seller: "dark",
    Buyer: "light"
 }
 export const protectHeader = ["/professional-info","/portfolio"];

/** Paths that do not require login. After logout or login, user stays on these pages if already there. */
export const publicPathPrefixes = [
  "/auth",
  "/login",
  "/signup",
  "/home",
  "/availability",
  "/messages",
  "/consultation-booking",
  "/consultancy-details",
  "/consultant-profile",
  "/client-profile",
  "/search-consultation",
  "/privacy-policy",
  "/terms-conditions",
  "/delete-account",
  "/client-faqs",
  "/consultant-faqs",
];

export function isPublicPath(pathname: string): boolean {
  if (!pathname || pathname === "/") return true;
  const normalized =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;
  // Keep in sync with CAMPAIGN_LANDING_SOURCES in utm-tracking.tsx
  if (
    normalized === "/linkedin" ||
    normalized === "/instagram" ||
    normalized === "/jobboard" ||
    normalized === "/utm" ||
    normalized.startsWith("/utm/")
  ) {
    return true;
  }
  return publicPathPrefixes.some(
    (prefix) => pathname === prefix || pathname.startsWith(prefix + "/")
  );
}

export const clendly_url = "";